/**
 * Enable all accordions that exist in the DOM at page load.
 */
window.accordion_tools.enableAccordions(document);
